/**
 * Constants for Store Selection feature
 *
 * These are Panther string identifiers, not display text. Resolve them through
 * `t(bundle, id)` from '@src/translationHelper' — the English source lives in
 * resources/translations.puff.json.
 */

// UI Text
export const STORE_LOAD_ERROR = 'jsma-web-storeSelection-loadError'
export const STORE_NOT_AUTHORIZED_ERROR = 'jsma-web-storeSelection-notAuthorizedError'
export const SET_STORE_ERROR = 'jsma-web-storeSelection-setStoreError'
export const SWITCH_STORE_ERROR = 'jsma-web-storeSelection-switchStoreError'
export const LOADING_STORES = 'jsma-web-storeSelection-loadingStores'
export const NO_STORES_FOUND = 'jsma-web-storeSelection-noStoresFound'
export const RETRY_BUTTON = 'migrated-ihm-seaward-provisioning-retry'
export const SWITCH_STORE_BUTTON = 'jsma-web-storeSelection-switchStoreButton'
export const SEARCH_PLACEHOLDER = 'jsma-web-storeSelection-searchPlaceholder'
export const HEADER_TEXT = 'jsma-web-storeSelection-header'
export const CHOOSE_STORE_DEFAULT = 'jsma-web-storeSelection-chooseStore'
export const SCAN_INTO_STORE = 'jsma-web-storeSelection-scanIntoStore'
export const BACK_TO_LOGIN = 'jwo-permissions-required-back-to-login'

// Store Item Badges
export const BADGE_CURRENT = 'jsma-web-storeSelection-badgeCurrent'
export const BADGE_SELECTED = 'jsma-web-storeSelection-badgeSelected'

// Aria Labels
export const ARIA_SWITCH_STORE_ENABLED = 'jsma-web-storeSelection-switchStoreEnabledLabel'
export const ARIA_SWITCH_STORE_DISABLED = 'jsma-web-storeSelection-switchStoreDisabledLabel'
export const ARIA_CURRENT_STORE = 'jsma-web-storeSelection-currentStoreLabel'

/**
 * Picks the store row aria-label variant for a store's state. The chosen string
 * takes a `storeName` argument.
 */
export const getStoreAriaLabelId = (isCurrent: boolean, isSelected: boolean): string => {
    if (isCurrent && isSelected) {
        return 'jsma-web-storeSelection-storeLabelCurrentSelected'
    } else if (isCurrent) {
        return 'jsma-web-storeSelection-storeLabelCurrent'
    } else if (isSelected) {
        return 'jsma-web-storeSelection-storeLabelSelected'
    }
    return 'jsma-web-storeSelection-storeLabel'
}
